import { __awaiter } from "tslib";
import { debug } from 'shared/utils';
/**
 * Conditionally load feed module when feed info exists
 */
const feedLoader = () => __awaiter(void 0, void 0, void 0, function* () {
    const ad = window.ADAPT.ad;
    if (!ad.feed || ad.feed.urls.length === 0) {
        return;
    }
    try {
        const module = yield import(
        /* webpackChunkName: "feed" */ './processFeed');
        window.ADAPT.ad = yield module.processFeed(ad);
    }
    catch (e) {
        debug('failed to load feed module', e);
    }
});
export default feedLoader;
